import styled, { createGlobalStyle } from 'styled-components';

export const AssetReportContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex: 1;
  box-sizing: border-box;
`;

export const PageModulesContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 5% 45% 45% 5%;
`;

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
  body {
    background-color: #EFF2F7;
  }
  .preview-page {
    margin-bottom: 24px !important;
  }
  @media print {
    .preview-page {
      margin-bottom: 0 !important;
    }
  }
`;
